import { loadStripe } from "@stripe/stripe-js";

// Stripe publishable key for the account (matches the sk_live_51FNs3s... server-side key)
// This is safe to expose client-side — it can only be used to tokenize payment info
const STRIPE_PUBLISHABLE_KEY = "pk_live_ujjo82vYnbuUrvfuPtryy42u00dqFmtEZl";

let stripePromise = null;

/**
 * Lazily load and return the Stripe.js instance.
 * Only loads once; subsequent calls return the cached promise.
 * @returns {Promise<import('@stripe/stripe-js').Stripe>}
 */
export function getStripe() {
    if (!stripePromise) {
        stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
    }
    return stripePromise;
}

export default getStripe;
